module.exports = require("js-yaml");


//////////////////
// WEBPACK FOOTER
// external "js-yaml"
// module id = 220
// module chunks = 0